// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import Mint from 'mint-ui';
import '../static/css/demo.css';
import 'element-ui/lib/theme-chalk/index.css';
import "mint-ui/lib/style.css"
import "../static/css/main.css";
import store from './store';

window.localStorage.isLogin = '0';

Vue.use(ElementUI);
Vue.use(Mint);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
if (to.matched.some(m => m.meta.auth)) {
    if (window.localStorage.isLogin === '1') {
      next()
    } else{
      next({path: '/login'})
      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
    }
} else {
    next()
}
})


// WEBPACK FOOTER //
// ./src/main.js